import styled, { css } from 'styled-components';
import Modal, { BaseModalBackground } from 'styled-react-modal';
import breakpoint from '../breakpoints';
import Typography from '../Typography';

export const Wrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  padding: 50px 15px 50px;
  ${breakpoint('tablet', 'down')}{
    padding-top: 35px;
  }
`

export const Intro = styled.div`
  margin-bottom: 25px;
`
export const Checkboxes = styled.div`
  text-align: left;
  margin: 0 auto;
  margin-bottom: 5px;
  column-count: 3;
  width: 80%;
  ${breakpoint('tablet', 'down')}{
    width: 90%;
    column-count: 2;
  }
  ${breakpoint('mobile')}{
    width: 93%;
  }
`
export const OptionsHeading = styled(Typography.BodyBold)`
    margin-bottom: 10px;
    display: block;
`
export const CheckboxInput = styled.label`
  width: 30%;
  box-sizing: border-box;
  padding-right: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  word-break: keep-all;

  input {
    height: 0;
    width: 0;
    overflow: hidden;
    opacity: 0;
    position: relative;

    &:checked + * {
      &:after {
        content: '';
        background: #cc0000;
        display: block;
        position: absolute;
        left: 50%;
        top: 50%;
        height: 50%;
        width: 50%;
        transform: translate3d(-50%, -50%, 0);
      }
    }
    &:focus + * {
      border-color: blue;
      border-color: -webkit-focus-ring-color;
    }
  }
`
export const CheckIcon = styled.span`
  height: 18px;
  width: 18px;
  flex-grow: 0;
  flex-shrink: 0;
  display: inline-block;
  border: 1px solid #CCC;
  position: relative;
  background: #FFF;
  margin-right: 15px;
  ${breakpoint('mobile')}{
    margin-right: 10px;
  }
`
export const TextInput = styled.div`
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #b2b2b2;
  position: relative;
  margin-bottom: 10px;
  padding: 20px;
  ${({ isValid }) => {
    switch(isValid) {
      case 'blue':
        return css`border-color: #69aefc;`
      case 'red':
        return css`border-color: #fd6c76;`
      default:
        return css`border-color: #b2b2b2;`
    }
  }}
  input,
  textarea {
    border: none;
    width: 100%;
  }

  textarea {
    min-height: 150px;
    resize: none;
  }
  .input-error {
    color: #fd6c76;
  }
  .input-success {
    color: #69aefc;
  }
`
export const  CtaWrapper = styled.div`
  padding-top: 15px;
`
export const OptionsInstructions = styled(Typography.BodySmall)`
  color: #666;
  margin-bottom: 25px;
  display: block;
`
export const InputWrapper = styled.div`
  display: flex;
`
export const StyledModal = Modal.styled`
  width: 700px;
  height: 600px;
  background-color: white;
  border: 1px solid;
  ${({ hasError }) => css`border-color: ${hasError ? 'red;' : '#69aefc;'}`}
`
export const ModalBody = styled.section`
  height: 560px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  transition: opacity ease 500ms;
  span, h3 {
    width: 60%;
  }
  button {
    margin-top: 55px;
  }
  &:first-child {
    justify-content: baseline;
  }
`
export const MessageWrapper = styled.div`

`

export const ModalHeading = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`
export const CloseButton = styled.img`
  padding: 10px 10px 0 0;
`

export const FadeBackground = styled(BaseModalBackground)`
  opacity: ${props => props.opacity};
  transition: opacity ease 200ms;
`

export const ToolTip = styled(Typography.Body)`
  font-size: 16px;
  z-index: 5;
  color: #fd6c76;
  padding-bottom: 10px;
`

export const FontBody = styled(Typography.Body)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

